import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store';
import 'animate.css/animate.min.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './libs/rem.js'
// import 'amfe-flexible'
Vue.use(ElementUI);
Vue.config.productionTip = false;



Vue.prototype.$Path = process.env.VUE_APP_PATH



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
